import React from 'react';
import Lottie from 'react-lottie';
import './Loader_Lottie.css';
import * as animationData from './Loader_Lottie.json';

function Loader_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
          
        } 
        
      };
    
    return (
      <section className='main'>
            <div className='Loader_Lottie_icon'>
                <Lottie className="me-auto" 
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Loader_Lottie;